/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SettlementDto } from '../../models/settlement-dto';

export interface SettlementControllerStartSettlement$Params {

/**
 * 정산 ID
 */
  id: string;
}

export function settlementControllerStartSettlement(http: HttpClient, rootUrl: string, params: SettlementControllerStartSettlement$Params, context?: HttpContext): Observable<StrictHttpResponse<SettlementDto>> {
  const rb = new RequestBuilder(rootUrl, settlementControllerStartSettlement.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SettlementDto>;
    })
  );
}

settlementControllerStartSettlement.PATH = '/api/settlement/{id}/start';
